// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"163":"Popup-next","195":"Popupv2","508":"Embed-next","666":"Embed","855":"Popup"}[chunkId] || chunkId) + "." + {"155":"044ff9dd","163":"c9b765f4","183":"867f9741","195":"933940bd","508":"295903f5","509":"6227b0f5","576":"6f5686d1","591":"f9485e21","666":"a7c23e8b","855":"7fc8cbf9"}[chunkId] + ".chunk.js";
};